import { KsefSendParametersSalePatternSendMode } from "./ksef-send-parameters-sale-pattern-send-mode";
import { KsefSendSubmissionMode } from "./ksef-send-submission-mode";

export class KsefSendParametersDTO {
	public id?: number;
	public sendDocumentNote: boolean;
	public sendWzNumbers: boolean;
    public sendSymbolAsIndeks: boolean;
    public sendBarCodeAsGTIN: boolean;
	public version: string;
	public documentTemplateSendMode: KsefSendParametersSalePatternSendMode;
    public defaultDocumentType: KsefSendSubmissionMode;
}
